import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cert-confirm-input-modal',
  templateUrl: './confirm-input-modal.component.html',
  styles: ``,
  standalone: false,
})
export class ConfirmInputModalComponent {
  header!: string;
  message!: string;
  confirmationInput!: string;

  constructor(private readonly activeModal: NgbActiveModal) {}

  onConfirm(confirmed: boolean): void {
    this.activeModal.close(confirmed);
  }

  confirmationInputEnteredIncorrectly(): boolean {
    return !this.confirmationInput || this.confirmationInput.toLowerCase() !== 'confirm';
  }
}
